<div class="antialiased bg-gray-50 dark:bg-gray-900 flex flex-col h-screen">
  <!-- Navbar -->
  <nav
    class="bg-white border-b border-gray-200 px-4 py-1.5 2xl:py-2.5 dark:bg-gray-800 dark:border-gray-700 sticky inset-x-0 z-50 flex flex-row justify-between items-center"
  >
    <!-- Navbar Div -->
    <!-- Logo (left) -->
    <div class="select-none flex flex-row items-center gap-4">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://landiq.com/land-iq-et"
        class="flex-shrink-0 flex items-center justify-between ml-1"
      >
        @if (isDarkMode) {
          <img
            src="/assets/svg/LIQ_DDA_dark.svg"
            class="h-6 2xl:h-8"
            alt="Flowbite Logo"
          />
        } @else {
          <img
            src="/assets/svg/LIQ_DDA_white.svg"
            class="h-6 2xl:h-8"
            alt="Flowbite Logo"
          />
        }
      </a>
      <!-- Switch to Demo Mode (internal user only) -->
      @if (allowDemo) {
        <div class="flex flex-row items-center gap-2">
          <app-dropdown
            class="flex-1 min-w-[10rem] self-stretch"
            [overwriteButtonStyle]="'text-xs 2xl:text-sm'"
            [overwriteStyle]="'text-sm 2xl:text-base'"
            [options]="modeOptions"
            [keyField]="'key'"
            [labelField]="'label'"
            [outputField]="'key'"
            [dropdownPlacement]="'bottom'"
            [(selectedKey)]="authService.internalModeValue"
          />
        </div>
      }
      @if (clientNameForManager()) {
        <h6
          class="text-xs font-medium text-gray-800 dark:text-gray-200 text-nowrap 2xl:text-base"
        >
          {{ clientNameForManager() }}
        </h6>
      }
    </div>

    <!-- Nav Components (right) -->
    <div class="flex flex-row items-center gap-4">
      <div class="flex flex-row items-center gap-2">
        <!-- Manager Statistic Dashboard -->
        @if (role() === "MANAGER") {
          <a
            routerLinkActive="router-link-active"
            [routerLink]="PATH.managerDashboard"
            (click)="navigateToComponent(PATH.managerDashboard)"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              aria-hidden="true"
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
              <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
            </svg>
            <span>Dashboard</span>
          </a>
        }
        <!-- Admin Dashboard & User Management (Admin only) -->
        @if (role() === "ADMIN") {
          <a
            routerLinkActive="router-link-active"
            [routerLink]="PATH.admin"
            (click)="navigateToComponent(PATH.admin)"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
              <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
            </svg>
            <span>Admin Dashboard</span>
          </a>
          <a
            routerLinkActive="router-link-active"
            [routerLink]="PATH.userManagement"
            (click)="navigateToComponent(PATH.userManagement)"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H6Zm7.25-2.095c.478-.86.75-1.85.75-2.905a5.973 5.973 0 0 0-.75-2.906 4 4 0 1 1 0 5.811ZM15.466 20c.34-.588.535-1.271.535-2v-1a5.978 5.978 0 0 0-1.528-4H18a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2h-4.535Z"
                clip-rule="evenodd"
              />
            </svg>
            <span>User Management</span>
          </a>
        }
        <!-- Dashboard (both Grower and Manager) -->
        @if (role() !== "ADMIN") {
          <a
            routerLinkActive="router-link-active"
            [routerLink]="
              role() === 'GROWER' ? PATH.growerDashboard
              : role() === 'MANAGER' ? PATH.managerFieldsView
              : PATH.entityFieldsView
            "
            (click)="redirectToDashboard()"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4.5V19a1 1 0 0 0 1 1h15M7 14l4-4 4 4 5-5m0 0h-3.207M20 9v3.207"
              />
            </svg>
            <span>Claimed Fields</span>
          </a>
          <!-- Fields Selection-->
          <a
            routerLinkActive="router-link-active"
            [routerLink]="
              role() === 'GROWER' ? PATH.field
              : role() === 'MANAGER' ? PATH.managerMapView
              : PATH.entityMapView
            "
            (click)="navigateToComponent()"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z"
                clip-rule="evenodd"
              />
            </svg>
            <span>Map</span>
          </a>
        }
        @if (role() === "MANAGER") {
          <a
            routerLinkActive="router-link-active"
            [routerLink]="PATH.userManagement"
            (click)="navigateToComponent(PATH.userManagement)"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H6Zm7.25-2.095c.478-.86.75-1.85.75-2.905a5.973 5.973 0 0 0-.75-2.906 4 4 0 1 1 0 5.811ZM15.466 20c.34-.588.535-1.271.535-2v-1a5.978 5.978 0 0 0-1.528-4H18a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2h-4.535Z"
                clip-rule="evenodd"
              />
            </svg>
            <span>User Management</span>
          </a>
        }

        @if (role() === "MANAGER" && is_field_email_validation) {
          <a
            routerLinkActive="router-link-active"
            [routerLink]="PATH.fieldConfig"
            (click)="navigateToComponent(PATH.fieldConfig)"
            class="flex flex-row justify-center items-center gap-2 p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group [&.router-link-active]:bg-gray-200 [&.router-link-active]:text-black [&.router-link-active:hover]:bg-gray-200 [&.router-link-active:hover]:text-gray-900 [&.router-link-active]:dark:bg-blue-700 [&.router-link-active]:dark:text-white [&.router-link-active:hover]:dark:bg-blue-700 [&.router-link-active:hover]:dark:text-white"
          >
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 group-[.router-link-active]:text-black group-[.router-link-active]:dark:text-white dark:text-gray-400 group-hover:text-gray-900 group-hover:dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857ZM18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
                clip-rule="evenodd"
              />
            </svg>

            <span>Field Config</span>
          </a>
        }
      </div>

      <!-- Divide line -->
      <div class="w-px h-6 2xl:h-8 bg-gray-600"></div>

      <div class="flex flex-row items-center gap-2">
        <!-- Help & Documents -->
        <details
          #helpDocumentsMenu
          class="relative group [&_summary::-webkit-details-marker]:hidden"
        >
          <summary
            class="list-none flex flex-row gap-2 items-center p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium cursor-pointer text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white"
          >
            <svg
              aria-hidden="true"
              class="flex-shrink-0 w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
              <path
                fill-rule="evenodd"
                d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>Help &amp; Documents</span>
            <svg
              aria-hidden="true"
              class="w-4 h-4 text-gray-500 transition-transform duration-200 group-open:rotate-180 dark:text-gray-400"
              fill="none"
              viewBox="0 0 10 6"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m1 1 4 4 4-4"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
          </summary>

          <div
            class="absolute right-0 top-full z-50 mt-2 min-w-[240px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800"
          >
            <button
              type="button"
              (click)="
                openDocFromMenu(
                  helpDocumentsMenu,
                  '/assets/pdf/20251217_IrrigationManagement_Guide.pdf',
                  'Help_Docs_of_LandIQDaily.pdf',
                  'Help Documentation'
                )
              "
              class="flex w-full items-center gap-2 px-4 py-3 text-left text-sm font-medium text-gray-900 transition duration-75 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
            >
              <span>Help</span>
            </button>

            <button
              type="button"
              (click)="
                openDocFromMenu(
                  helpDocumentsMenu,
                  '/assets/pdf/20251103_TermsandConditions_Final.pdf',
                  'TermsandConditions.pdf',
                  'Terms and Conditions'
                )
              "
              class="flex w-full items-center gap-2 px-4 py-3 text-left text-sm font-medium text-gray-900 transition duration-75 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
            >
              <span>Terms &amp; Conditions</span>
            </button>

            <button
              type="button"
              (click)="
                openDocFromMenu(
                  helpDocumentsMenu,
                  '/assets/pdf/20251103_PrivacyPolicy_Final.pdf',
                  'PrivacyPolicy.pdf',
                  'Privacy Policy'
                )
              "
              class="flex w-full items-center gap-2 px-4 py-3 text-left text-sm font-medium text-gray-900 transition duration-75 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
            >
              <span>Privacy Policy</span>
            </button>
          </div>
        </details>

        <!-- Contact -->
        <a
          (click)="toggleContactModel()"
          class="flex flex-row gap-2 items-center p-1.5 2xl:p-2 text-sm 2xl:text-base font-medium text-gray-900 cursor-pointer rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
        >
          <svg
            class="flex-shrink-0 w-5 h-5 2xl:w-6 2xl:h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M2.038 5.61A2.01 2.01 0 0 0 2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-.12-.01-.238-.03-.352l-.866.65-7.89 6.032a2 2 0 0 1-2.429 0L2.884 6.288l-.846-.677Z"
            />
            <path
              d="M20.677 4.117A1.996 1.996 0 0 0 20 4H4c-.225 0-.44.037-.642.105l.758.607L12 10.742 19.9 4.7l.777-.583Z"
            />
          </svg>
          <span>Contact</span>
        </a>
      </div>

      <div class="w-px h-6 2xl:h-8 bg-gray-600"></div>

      <div class="flex flex-row items-center gap-2">
        <button
          (click)="setMode()"
          type="button"
          class="p-1.5 2xl:p-2 mr-1 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
          id="mode-button"
        >
          @if (isDarkMode) {
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-800 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M11.675 2.015a.998.998 0 0 0-.403.011C6.09 2.4 2 6.722 2 12c0 5.523 4.477 10 10 10 4.356 0 8.058-2.784 9.43-6.667a1 1 0 0 0-1.02-1.33c-.08.006-.105.005-.127.005h-.001l-.028-.002A5.227 5.227 0 0 0 20 14a8 8 0 0 1-8-8c0-.952.121-1.752.404-2.558a.996.996 0 0 0 .096-.428V3a1 1 0 0 0-.825-.985Z"
                clip-rule="evenodd"
              />
            </svg>
          } @else {
            <svg
              class="w-5 h-5 2xl:w-6 2xl:h-6 text-gray-800 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fill-rule="evenodd"
                d="M13 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V3ZM6.343 4.929A1 1 0 0 0 4.93 6.343l1.414 1.414a1 1 0 0 0 1.414-1.414L6.343 4.929Zm12.728 1.414a1 1 0 0 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 1.414 1.414l1.414-1.414ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-9 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H3Zm16 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2ZM7.757 17.657a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414Zm9.9-1.414a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414ZM13 19a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z"
                clip-rule="evenodd"
              />
            </svg>
          }
        </button>

        <!-- Notifications -->
        <!-- <button
          type="button"
          data-dropdown-toggle="notification-dropdown"
          class="p-2 mr-1 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
        >
          <span class="sr-only">View notifications</span>
          <svg
            aria-hidden="true"
            class="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
            ></path>
          </svg>
        </button> -->
        <!-- Dropdown menu -->
        <!-- <div
          class="hidden overflow-hidden z-50 my-4 max-w-sm text-base list-none bg-white rounded divide-y divide-gray-100 shadow-lg dark:divide-gray-600 dark:bg-gray-700"
          id="notification-dropdown"
        >
          <div
            class="block py-2 px-4 text-base font-medium text-center text-gray-700 bg-gray-50 dark:bg-gray-600 dark:text-gray-300"
          >
            Notifications (Now Dummy, Comming Soon)
          </div>

          <div class="max-h-96 overflow-y-auto">
            <a
              class="flex py-3 px-4 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600"
            >
              <div class="pl-3 w-full">
                <div
                  class="text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400"
                >
                  <span class="font-semibold text-gray-900 dark:text-white"
                    >Notification 1</span
                  >: Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Itaque atque sit nisi at ea
                </div>
                <div
                  class="text-xs font-medium text-primary-600 dark:text-primary-500"
                >
                  Time: ...
                </div>
              </div>
            </a>
            <a
              class="flex py-3 px-4 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600"
            >
              <div class="pl-3 w-full">
                <div
                  class="text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400"
                >
                  <span class="font-semibold text-gray-900 dark:text-white"
                    >Notification 2</span
                  >: Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Itaque atque sit nisi at ea
                </div>
                <div
                  class="text-xs font-medium text-primary-600 dark:text-primary-500"
                >
                  Time: ...
                </div>
              </div>
            </a>
            <a
              class="flex py-3 px-4 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600"
            >
              <div class="pl-3 w-full">
                <div
                  class="text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400"
                >
                  <span class="font-semibold text-gray-900 dark:text-white"
                    >Notification 3</span
                  >: Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Itaque atque sit nisi at ea
                </div>
                <div
                  class="text-xs font-medium text-primary-600 dark:text-primary-500"
                >
                  Time: ...
                </div>
              </div>
            </a>
          </div>
        </div> -->

        <button
          type="button"
          class="p-1.5 2xl:p-2 mr-1 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
          id="user-menu-button"
          aria-expanded="false"
          data-dropdown-toggle="dropdown"
        >
          <span class="sr-only">Open user menu</span>
          <svg
            class="w-5 h-5 2xl:w-6 2xl:h-6"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M12 20a7.966 7.966 0 0 1-5.002-1.756l.002.001v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10h-.138C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <!-- Dropdown menu -->
        <div
          class="hidden z-50 my-4 mr-10 w-64 text-base list-none bg-white divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 rounded-xl overflow-clip"
          id="dropdown"
        >
          <div class="py-3 px-4">
            <span
              class="block text-sm font-semibold text-gray-900 dark:text-white"
            >
              {{ userName }}
            </span>
            <span
              class="block text-xs font-medium uppercase text-gray-500 dark:text-gray-300"
            >
              {{ role() }}
            </span>
            <span class="block text-sm text-gray-900 truncate dark:text-white">
              {{ email }}
            </span>
          </div>
          <!-- <ul
            class="py-1 text-gray-700 dark:text-gray-300 cursor-pointer"
            aria-labelledby="dropdown"
          >
            <li>
              <a
                class="flex items-center py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                <svg
                  class="mr-2 w-5 h-5 text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm10 5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm-8-5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm1.942 4a3 3 0 0 0-2.847 2.051l-.044.133-.004.012c-.042.126-.055.167-.042.195.006.013.02.023.038.039.032.025.08.064.146.155A1 1 0 0 0 6 17h6a1 1 0 0 0 .811-.415.713.713 0 0 1 .146-.155c.019-.016.031-.026.038-.04.014-.027 0-.068-.042-.194l-.004-.012-.044-.133A3 3 0 0 0 10.059 14H7.942Z"
                    clip-rule="evenodd"
                  />
                </svg>
                My Profile</a
              >
            </li>
          </ul> -->
          <ul
            class="flex flex-col py-1 text-gray-700 dark:text-gray-300 cursor-pointer"
            aria-labelledby="dropdown"
          >
            @if (
              (this.role() === "GROWER" || this.role() === "ENTITY") && false
            ) {
              <li>
                <button
                  (click)="openEmailPreferencesModel()"
                  class="w-full flex items-center flex-row gap-2 py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <svg
                    class="w-5 h-5 text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M2.038 5.61A2.01 2.01 0 0 0 2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-.12-.01-.238-.03-.352l-.866.65-7.89 6.032a2 2 0 0 1-2.429 0L2.884 6.288l-.846-.677Z"
                    />
                    <path
                      d="M20.677 4.117A1.996 1.996 0 0 0 20 4H4c-.225 0-.44.037-.642.105l.758.607L12 10.742 19.9 4.7l.777-.583Z"
                    />
                  </svg>
                  Email Preferences
                </button>
              </li>
            }
            <li class="w-full">
              <button
                (click)="signOut()"
                class="w-full flex items-center py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
              >
                <svg
                  class="mr-2 w-5 h-5 text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
                  />
                </svg>
                Sign out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <!-- Main Board -->
  <!-- overflow-hidden h-screen -->
  <main class="p-2.5 pb-2 flex-1 overflow-y-auto">
    <router-outlet></router-outlet>
  </main>
</div>
<app-doc></app-doc>
<app-contact></app-contact>
<app-email-preferences></app-email-preferences>
@if (false) {
  <app-welcome></app-welcome>
}
